// src/components/admin/DataDisplay.js

import React from "react";
import { Box, Typography } from "@mui/material";

const DataDisplay = ({ data, level = 0 }) => {
  if (!data) return null;

  return (
    <Box sx={{ pl: level * 2, mt: 1 }}>
      {Object.entries(data).map(([key, value]) => {
        // Check if value is an object (and not an array)
        if (
          typeof value === "object" &&
          value !== null &&
          !Array.isArray(value)
        ) {
          return (
            <Box key={key} sx={{ mb: 1 }}>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  color: "#666",
                  fontFamily: "arial, sans-serif",
                }}
              >
                {key}:
              </Typography>
              <DataDisplay data={value} level={level + 1} />
            </Box>
          );
        } else if (Array.isArray(value)) {
          return (
            <Box key={key} sx={{ mb: 1 }}>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  color: "#333",
                  fontFamily: "arial, sans-serif",
                }}
              >
                {key}:
              </Typography>
              {value.map((item, index) => (
                <Box key={index} sx={{ pl: 2 }}>
                  {typeof item === "object" ? (
                    <DataDisplay data={item} level={level + 1} />
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{ fontFamily: "arial, sans-serif" }}
                    >
                      {item}
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
          );
        } else {
          return (
            <Typography key={key} variant="body2">
              <span
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontFamily: "arial, sans-serif",
                }}
              >
                {key}:
              </span>{" "}
              <span style={{ color: "black", fontFamily: "arial, sans-serif" }}>
                {String(value)}
              </span>
            </Typography>
          );
        }
      })}
    </Box>
  );
};

export default DataDisplay;
